import VideoPokerMenu from './VideoPokerMenu';

export default VideoPokerMenu;
